<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="absolute right-0 top-12 z-[100] w-[520px] max-h-[420px] overflow-y-auto rounded-xl border border-slate-200 bg-white p-5 shadow-xl">
    <div v-for="(notification, index) in visibleNotifications" :key="notification.id || index">
      <div class="flex items-start justify-between gap-3">
        <button type="button" class="flex flex-1 items-start gap-4 text-left" @click="emit('openNotification', notification)">
          <div class="mt-1 grid h-10 w-10 shrink-0 place-items-center rounded-full bg-rose-100 text-rose-600">
            <i class="fa-solid fa-triangle-exclamation"></i>
          </div>

          <div class="min-w-0">
            <p class="text-sm font-semibold text-slate-800">{{ notification.title || 'Erro de integração' }}</p>
            <p class="mt-1 text-sm text-slate-600">{{ notification.msg }}</p>
            <div class="mt-3 flex flex-wrap items-center gap-3 text-xs text-slate-400">
              <span>{{ notification.integrationName || 'Integração' }}</span>
              <span>{{ formatDate(notification.createdAt) }}</span>
              <span v-if="notification.routePath" class="font-medium text-sky-600">Abrir tela</span>
            </div>
          </div>
        </button>

        <button type="button" class="shrink-0 text-slate-400 transition hover:text-slate-600" @click="emit('readNotification', notification)">
          <i class="fas fa-times"></i>
        </button>
      </div>

      <hr v-if="index < visibleNotifications.length - 1" class="my-5 w-full" />
    </div>

    <div v-if="notifications.length === 0" class="py-6 text-center text-sm text-slate-500">Nenhuma notificação nova</div>

    <div v-if="visibleCount < notifications.length" class="mt-4 text-center">
      <button @click="showMore" class="text-sm font-medium text-sky-600 underline underline-offset-2">
        Mostrar mais
      </button>
    </div>

    <div class="mt-5 border-t border-slate-200 pt-4 text-center">
      <button
        type="button"
        class="text-sm font-semibold text-sky-700 transition hover:text-sky-900"
        @click="emit('openHistory')">
        Ver histórico de notificações
      </button>
    </div>
  </div>
</template>

<script setup>
/* eslint-disable vue/multi-word-component-names */
import { computed, defineEmits, defineProps, ref } from 'vue'
import { useFormat } from '@/composables/useFormat'

const { formatDate } = useFormat()

const visibleCount = ref(3)

const props = defineProps({
  notifications: {
    type: Array,
    default: () => [],
  },
})

const emit = defineEmits(['openNotification', 'readNotification', 'openHistory'])

const visibleNotifications = computed(() => props.notifications.slice(0, visibleCount.value))

const showMore = () => {
  visibleCount.value += 3
}
</script>
